var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgSandclock = function SvgSandclock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58 1.5H7v-1h51v1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5.5h38V15c0 9.665-7.835 17.5-17.5 17.5h-3c-9.665 0-17.5-7.835-17.5-17.5V.5zm1 1V15c0 9.113 7.387 16.5 16.5 16.5h3c9.113 0 16.5-7.387 16.5-16.5V1.5h-36z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 63.5h51v1H7v-1z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.5 64.5h-38V49c0-9.665 7.835-17.5 17.5-17.5h3c9.665 0 17.5 7.835 17.5 17.5v15.5zm-1-1V49c0-9.113-7.387-16.5-16.5-16.5h-3c-9.113 0-16.5 7.387-16.5 16.5v14.5h36z"
  })));
};
export default SvgSandclock;